import { render, staticRenderFns } from "./formEditVehicle.vue?vue&type=template&id=67afd079"
import script from "./formEditVehicle.vue?vue&type=script&lang=js"
export * from "./formEditVehicle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67afd079')) {
      api.createRecord('67afd079', component.options)
    } else {
      api.reload('67afd079', component.options)
    }
    module.hot.accept("./formEditVehicle.vue?vue&type=template&id=67afd079", function () {
      api.rerender('67afd079', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/transport/vehicle/components/form/formEditVehicle.vue"
export default component.exports